import { e as Q, d as v, f as Y, h as E, j as W, k as L, l as _, n as F, o as ae, p as U, q as J, r as H, t as Z, u as V, v as X, w as G, b as r } from "./index-E8vB_04G.js";
import { l as N } from "./index-b-LDu0Rp.js";
import { C as u } from "./types-CMDdNX_5.js";
import { intelSgxDcapRootCa as ce, amdSnpArkPem as oe } from "./certs.js";
import { GcgDriverDecoder as q } from "./compute.js";
import { h as j } from "./utils-dinPOBnH.js";
import "./config.js";
import "sgx-ias-verifier";
import "./nacl-fast-DmSj04OB.js";
import { a as te } from "./session-DyDHabUm.js";
import "ddc";
class he {
  /**
   * Create a container compute node. See [[`CreateStaticContainerComputeOptions`]]
   * for the list of options that need to be specified.
   */
  constructor(c, {
    command: t,
    mountPoints: o,
    outputPath: f,
    enclaveType: b,
    includeContainerLogsOnError: s,
    includeContainerLogsOnSuccess: l
  }) {
    this.name = c, this.enclaveType = b, this.config = Q.ContainerWorkerConfiguration.encodeDelimited({
      static: {
        command: t,
        includeContainerLogsOnError: s,
        includeContainerLogsOnSuccess: l,
        mountPoints: o,
        outputPath: f
      }
    }).finish(), this.dependencies = o.map((k) => k.dependency);
  }
  config;
  dependencies;
  outputFormat = v.ComputeNodeFormat.ZIP;
  enclaveType;
}
class n extends u {
  decode(c) {
    return Q.ContainerWorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
class z extends u {
  decode(c) {
    return Y.PostWorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
class ge {
  constructor(c, t, {
    useMockBackend: o = !1
  }) {
    this.name = c, this.dependencies = [t], this.config = Y.PostWorkerConfiguration.encodeDelimited({
      useMockBackend: o
    }).finish();
  }
  config;
  outputFormat = v.ComputeNodeFormat.ZIP;
  enclaveType = "decentriq.post-worker";
  dependencies;
}
class Ae {
  /** __S3Sink Compute Node__
   *
   * *Request Authentication* credentials must be provided as `StaticContent` in JSON
   * format.
   * - AWS: Requires JSON containing `accessKey` and `secretKey`. Request is authenticated with `secretKey`.
   * - GCS: Requires JSON containing [service account credentials](https://cloud.google.com/iam/docs/service-account-creds).
   */
  constructor(c, {
    endpoint: t,
    region: o,
    credentialsDependency: f,
    useSplickyCredentials: b = !1,
    objects: s,
    s3Provider: l,
    contentType: k
  }) {
    this.name = c;
    let C;
    switch (l) {
      case "AWS":
        C = E.S3Provider.AWS;
        break;
      case "GCS":
        C = E.S3Provider.GCS;
        break;
      default:
        throw new Error(`Invalid s3Provider: ${l}`);
    }
    if (f)
      this.config = E.S3SinkWorkerConfiguration.encodeDelimited({
        endpoint: t,
        objects: s,
        region: o,
        s3Provider: C,
        userDefinedCredentials: {
          userDefinedCredentials: f
        },
        ...k ? { contentType: k } : {}
      }).finish(), this.dependencies = [
        f,
        ...s.map((y) => y.dependency)
      ];
    else if (b)
      this.config = E.S3SinkWorkerConfiguration.encodeDelimited({
        dqDspCredentials: {
          dspType: E.DspCredentialsType.SPLICKY
        },
        endpoint: t,
        objects: s,
        region: o,
        s3Provider: C
      }).finish(), this.dependencies = [...s.map((y) => y.dependency)];
    else
      throw new Error(
        "Neither user defined credentials nor Splicky credentials were specified"
      );
  }
  config;
  dependencies;
  enclaveType = "decentriq.s3-sink-worker";
  outputFormat = v.ComputeNodeFormat.RAW;
}
class D extends u {
  decode(c) {
    return E.S3SinkWorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
class $ {
  constructor(c, t, o) {
    this.name = c, this.config = t, this.dependencies = o;
  }
  enclaveType = "decentriq.sql-worker";
  outputFormat = v.ComputeNodeFormat.ZIP;
  static async create(c, t, o, { privacySettings: f, constraints: b } = {}) {
    const s = W.SqlWorkerConfiguration.create({
      computation: {
        constraints: b,
        privacySettings: f,
        sqlStatement: t,
        tableDependencyMappings: o.map(([C, y]) => ({
          dependency: y,
          table: C
        }))
      }
    }), l = W.SqlWorkerConfiguration.encodeDelimited(
      s
    ).finish(), k = o.map(([C, y]) => y);
    return new $(c, l, k);
  }
}
class Pe {
  constructor(c, t, o) {
    this.name = c;
    const f = o.map(
      ([s, l, k]) => W.NamedColumn.create({
        columnType: {
          nullable: k,
          primitiveType: l
        },
        name: s
      })
    ), b = W.SqlWorkerConfiguration.create({
      validation: {
        tableSchema: {
          namedColumns: f
        }
      }
    });
    this.config = W.SqlWorkerConfiguration.encodeDelimited(
      b
    ).finish(), this.dependencies = [t];
  }
  config;
  enclaveType = "decentriq.sql-worker";
  outputFormat = v.ComputeNodeFormat.ZIP;
  dependencies;
}
class K extends u {
  decode(c) {
    return W.SqlWorkerConfiguration.decodeDelimited(c).toJSON();
  }
}
const de = `{"signatures":[{"keyid":"ff51e17fcf253119b7033f6f57512631da4a0969442afcf9fc8b141c7f2be99c","sig":"3045022100fc1c2be509ce50ea917bbad1d9efe9d96c8c2ebea04af2717aa3d9c6fe617a75022012eef282a19f2d8bd4818aa333ef48a06489f49d4d34a20b8fe8fc867bb25a7a"},{"keyid":"25a0eb450fd3ee2bd79218c963dce3f1cc6118badf251bf149f0bd07d5cabe99","sig":"30450221008a4392ae5057fc00778b651e61fea244766a4ae58db84d9f1d3810720ab0f3b702207c49e59e8031318caf02252ecea1281cecc1e5986c309a9cef61f455ecf7165d"},{"keyid":"7f7513b25429a64473e10ce3ad2f3da372bbdd14b65d07bbaf547e7c8bbbe62b","sig":"3046022100da1b8dc5d53aaffbbfac98de3e23ee2d2ad3446a7bed09fac0f88bae19be2587022100b681c046afc3919097dfe794e0d819be891e2e850aade315bec06b0c4dea221b"},{"keyid":"2e61cd0cbf4a8f45809bda9f7f78c0d33ad11842ff94ae340873e2664dc843de","sig":"3046022100b534e0030e1b271133ecfbdf3ba9fbf3becb3689abea079a2150afbb63cdb7c70221008c39a718fd9495f249b4ab8788d5b9dc269f0868dbe38b272f48207359d3ded9"},{"keyid":"2f64fb5eac0cf94dd39bb45308b98920055e9a0d8e012a7220787834c60aef97","sig":"3045022100fc1c2be509ce50ea917bbad1d9efe9d96c8c2ebea04af2717aa3d9c6fe617a75022012eef282a19f2d8bd4818aa333ef48a06489f49d4d34a20b8fe8fc867bb25a7a"},{"keyid":"eaf22372f417dd618a46f6c627dbc276e9fd30a004fc94f9be946e73f8bd090b","sig":"30450221008a4392ae5057fc00778b651e61fea244766a4ae58db84d9f1d3810720ab0f3b702207c49e59e8031318caf02252ecea1281cecc1e5986c309a9cef61f455ecf7165d"},{"keyid":"f505595165a177a41750a8e864ed1719b1edfccd5a426fd2c0ffda33ce7ff209","sig":"3046022100da1b8dc5d53aaffbbfac98de3e23ee2d2ad3446a7bed09fac0f88bae19be2587022100b681c046afc3919097dfe794e0d819be891e2e850aade315bec06b0c4dea221b"},{"keyid":"75e867ab10e121fdef32094af634707f43ddd79c6bab8ad6c5ab9f03f4ea8c90","sig":"3046022100b534e0030e1b271133ecfbdf3ba9fbf3becb3689abea079a2150afbb63cdb7c70221008c39a718fd9495f249b4ab8788d5b9dc269f0868dbe38b272f48207359d3ded9"}],"signed":{"_type":"root","consistent_snapshot":true,"expires":"2023-04-18T18:13:43Z","keys":{"25a0eb450fd3ee2bd79218c963dce3f1cc6118badf251bf149f0bd07d5cabe99":{"keyid_hash_algorithms":["sha256","sha512"],"keytype":"ecdsa-sha2-nistp256","keyval":{"public":"-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEEXsz3SZXFb8jMV42j6pJlyjbjR8K
N3Bwocexq6LMIb5qsWKOQvLN16NUefLc4HswOoumRsVVaajSpQS6fobkRw==
-----END PUBLIC KEY-----
"},"scheme":"ecdsa-sha2-nistp256"},"2e61cd0cbf4a8f45809bda9f7f78c0d33ad11842ff94ae340873e2664dc843de":{"keyid_hash_algorithms":["sha256","sha512"],"keytype":"ecdsa-sha2-nistp256","keyval":{"public":"-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAE0ghrh92Lw1Yr3idGV5WqCtMDB8Cx
+D8hdC4w2ZLNIplVRoVGLskYa3gheMyOjiJ8kPi15aQ2//7P+oj7UvJPGw==
-----END PUBLIC KEY-----
"},"scheme":"ecdsa-sha2-nistp256"},"45b283825eb184cabd582eb17b74fc8ed404f68cf452acabdad2ed6f90ce216b":{"keyid_hash_algorithms":["sha256","sha512"],"keytype":"ecdsa-sha2-nistp256","keyval":{"public":"-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAELrWvNt94v4R085ELeeCMxHp7PldF
0/T1GxukUh2ODuggLGJE0pc1e8CSBf6CS91Fwo9FUOuRsjBUld+VqSyCdQ==
-----END PUBLIC KEY-----
"},"scheme":"ecdsa-sha2-nistp256"},"7f7513b25429a64473e10ce3ad2f3da372bbdd14b65d07bbaf547e7c8bbbe62b":{"keyid_hash_algorithms":["sha256","sha512"],"keytype":"ecdsa-sha2-nistp256","keyval":{"public":"-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEinikSsAQmYkNeH5eYq/CnIzLaacO
xlSaawQDOwqKy/tCqxq5xxPSJc21K4WIhs9GyOkKfzueY3GILzcMJZ4cWw==
-----END PUBLIC KEY-----
"},"scheme":"ecdsa-sha2-nistp256"},"e1863ba02070322ebc626dcecf9d881a3a38c35c3b41a83765b6ad6c37eaec2a":{"keyid_hash_algorithms":["sha256","sha512"],"keytype":"ecdsa-sha2-nistp256","keyval":{"public":"-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEWRiGr5+j+3J5SsH+Ztr5nE2H2wO7
BV+nO3s93gLca18qTOzHY1oWyAGDykMSsGTUBSt9D+An0KfKsD2mfSM42Q==
-----END PUBLIC KEY-----
"},"scheme":"ecdsa-sha2-nistp256"},"f5312f542c21273d9485a49394386c4575804770667f2ddb59b3bf0669fddd2f":{"keyid_hash_algorithms":["sha256","sha512"],"keytype":"ecdsa-sha2-nistp256","keyval":{"public":"-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEzBzVOmHCPojMVLSI364WiiV8NPrD
6IgRxVliskz/v+y3JER5mcVGcONliDcWMC5J2lfHmjPNPhb4H7xm8LzfSA==
-----END PUBLIC KEY-----
"},"scheme":"ecdsa-sha2-nistp256"},"ff51e17fcf253119b7033f6f57512631da4a0969442afcf9fc8b141c7f2be99c":{"keyid_hash_algorithms":["sha256","sha512"],"keytype":"ecdsa-sha2-nistp256","keyval":{"public":"-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEy8XKsmhBYDI8Jc0GwzBxeKax0cm5
STKEU65HPFunUn41sT8pi0FjM4IkHz/YUmwmLUO0Wt7lxhj6BkLIK4qYAw==
-----END PUBLIC KEY-----
"},"scheme":"ecdsa-sha2-nistp256"}},"roles":{"root":{"keyids":["ff51e17fcf253119b7033f6f57512631da4a0969442afcf9fc8b141c7f2be99c","25a0eb450fd3ee2bd79218c963dce3f1cc6118badf251bf149f0bd07d5cabe99","f5312f542c21273d9485a49394386c4575804770667f2ddb59b3bf0669fddd2f","7f7513b25429a64473e10ce3ad2f3da372bbdd14b65d07bbaf547e7c8bbbe62b","2e61cd0cbf4a8f45809bda9f7f78c0d33ad11842ff94ae340873e2664dc843de"],"threshold":3},"snapshot":{"keyids":["45b283825eb184cabd582eb17b74fc8ed404f68cf452acabdad2ed6f90ce216b"],"threshold":1},"targets":{"keyids":["ff51e17fcf253119b7033f6f57512631da4a0969442afcf9fc8b141c7f2be99c","25a0eb450fd3ee2bd79218c963dce3f1cc6118badf251bf149f0bd07d5cabe99","f5312f542c21273d9485a49394386c4575804770667f2ddb59b3bf0669fddd2f","7f7513b25429a64473e10ce3ad2f3da372bbdd14b65d07bbaf547e7c8bbbe62b","2e61cd0cbf4a8f45809bda9f7f78c0d33ad11842ff94ae340873e2664dc843de"],"threshold":3},"timestamp":{"keyids":["e1863ba02070322ebc626dcecf9d881a3a38c35c3b41a83765b6ad6c37eaec2a"],"threshold":1}},"spec_version":"1.0","version":5}}`;
class Ce {
  constructor(c, { segmentOwners: t, input: o }) {
    this.name = c, this.config = L.AdformDspWorkerConfiguration.encodeDelimited({
      input: o,
      segmentOwners: t
    }).finish(), this.dependencies = [o.dependency];
  }
  config;
  enclaveType = "decentriq.adform-dsp-worker";
  dependencies;
  outputFormat = v.ComputeNodeFormat.RAW;
}
class O extends u {
  decode(c) {
    return L.AdformDspWorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
class ye {
  constructor(c, { credentialsDependency: t }) {
    this.name = c, this.config = _.AzureBlobStorageWorkerConfiguration.encodeDelimited({
      credentialsDependency: t,
      importRole: {}
    }).finish(), this.dependencies = [t];
  }
  config;
  enclaveType = "decentriq.azure-blob-storage-worker";
  dependencies;
  outputFormat = v.ComputeNodeFormat.RAW;
}
class Re {
  constructor(c, { credentialsDependency: t, input: o }) {
    this.name = c, this.config = _.AzureBlobStorageWorkerConfiguration.encodeDelimited({
      credentialsDependency: t,
      exportRole: { input: o }
    }).finish(), this.dependencies = [o.dependency, t];
  }
  config;
  enclaveType = "decentriq.azure-blob-storage-worker";
  dependencies;
  outputFormat = v.ComputeNodeFormat.RAW;
}
class M extends u {
  decode(c) {
    return _.AzureBlobStorageWorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
class ne {
  /** DataSourceS3 Compute Node__
   *
   * *Request Authentication* credentials must be provided as `StaticContent` in JSON
   * format.
   * - AWS: Requires JSON containing `accessKey` and `secretKey`. Request is authenticated with `secretKey`.
   * - GCS: Requires JSON containing [service account credentials](https://cloud.google.com/iam/docs/service-account-creds).
   */
  constructor(c, {
    bucket: t,
    region: o,
    objectKey: f,
    credentialsDependency: b,
    s3Provider: s
  }) {
    this.name = c;
    let l;
    switch (s) {
      case "AWS":
        l = F.S3Provider.AWS;
        break;
      case "GCS":
        l = F.S3Provider.GCS;
        break;
      default:
        throw new Error(`Unsupported s3Provider: ${s}`);
    }
    this.config = F.DataSourceS3WorkerConfiguration.encodeDelimited({
      credentialsDependency: b,
      s3Provider: l,
      source: {
        bucket: t,
        ...s === "AWS" ? { region: o } : {},
        objectKey: f
      }
    }).finish(), this.dependencies = [b];
  }
  config;
  enclaveType = "decentriq.data-source-s3-worker";
  dependencies;
  outputFormat = v.ComputeNodeFormat.RAW;
}
class S extends u {
  decode(c) {
    return F.DataSourceS3WorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
const Ke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DataSourceS3: ne,
  DataSourceS3WorkerDecoder: S
}, Symbol.toStringTag, { value: "Module" }));
class B extends u {
  decode(c) {
    return ae.DataSourceSnowflakeWorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
class Ie {
  constructor(c, {
    inputs: t,
    encryptionKeyDependency: o,
    datasetImportId: f,
    isKeyHexEncoded: b = !1
  }) {
    this.name = c, this.config = U.DatasetSinkWorkerConfiguration.encodeDelimited({
      datasetImportId: f,
      encryptionKeyDependency: o,
      inputs: t,
      isKeyHexEncoded: b
    }).finish(), this.dependencies = t.map((s) => s.dependency).concat(o);
  }
  config;
  enclaveType = "decentriq.dataset-sink-worker";
  dependencies;
  outputFormat = v.ComputeNodeFormat.ZIP;
}
class A extends u {
  decode(c) {
    return U.DatasetSinkWorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
class Ee {
  constructor(c, t, o, f, b, s, l, k) {
    this.name = c, this.input = t, this.credentialsDependency = o, this.identifierKind = f, this.listId = b, this.inputHasHeaders = s, this.bucket = l, this.objectName = k, this.config = J.GoogleAdManagerWorkerConfiguration.encodeDelimited({
      bucket: l,
      credentialsDependency: o,
      identifierKind: f,
      input: t,
      inputHasHeaders: s,
      listId: b,
      objectName: k
    }).finish(), this.dependencies = [t.dependency, o];
  }
  config;
  enclaveType = "decentriq.google-ad-manager-worker";
  dependencies;
  outputFormat = v.ComputeNodeFormat.RAW;
}
class R extends u {
  decode(c) {
    return J.GoogleAdManagerWorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
class We {
  constructor(c, {
    input: t,
    credentialsDependency: o,
    advertiserId: f,
    displayName: b,
    description: s,
    membershipDurationDays: l,
    userConsentGiven: k
  }) {
    this.name = c, this.config = H.GoogleDv360SinkWorkerConfiguration.encodeDelimited({
      advertiserId: f,
      credentialsDependency: o,
      description: s,
      displayName: b,
      input: t,
      membershipDurationDays: l,
      userConsentGiven: k
    }).finish(), this.dependencies = [t.dependency, o];
  }
  config;
  enclaveType = "decentriq.google-dv-360-sink-worker";
  dependencies;
  outputFormat = v.ComputeNodeFormat.RAW;
}
class h extends u {
  decode(c) {
    return H.GoogleDv360SinkWorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
class Ne {
  constructor(c, {
    input: t,
    accessTokenDependency: o,
    adAccountId: f,
    audienceName: b,
    apiVersion: s = "21.0"
  }) {
    this.name = c, this.config = Z.MetaSinkWorkerConfiguration.encodeDelimited({
      accessTokenDependency: o,
      adAccountId: f,
      apiVersion: s,
      audienceName: b,
      input: t
    }).finish(), this.dependencies = [t.dependency, o];
  }
  config;
  enclaveType = "decentriq.meta-sink-worker";
  dependencies;
  outputFormat = v.ComputeNodeFormat.RAW;
}
class g extends u {
  decode(c) {
    return Z.MetaSinkWorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
class Me {
  constructor(c, {
    input: t,
    memberId: o,
    memberName: f,
    segmentShortName: b,
    segmentCode: s
  }) {
    this.name = c, this.config = V.MicrosoftDspWorkerConfiguration.encodeDelimited(
      {
        input: t,
        memberInfo: {
          id: parseInt(o),
          name: f
        },
        segmentInfo: {
          code: s,
          shortName: b
        }
      }
    ).finish(), this.dependencies = [t.dependency];
  }
  config;
  enclaveType = "decentriq.microsoft-dsp-worker";
  dependencies;
  outputFormat = v.ComputeNodeFormat.RAW;
}
class T extends u {
  decode(c) {
    return V.MicrosoftDspWorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
class Be {
  constructor(c, {
    credentialsDependency: t,
    input: o,
    importId: f,
    segmentName: b,
    segmentCode: s,
    inputHasHeaders: l
  }) {
    this.name = c, this.config = X.PermutiveWorkerConfiguration.encodeDelimited({
      credentialsDependency: t,
      exportRole: { input: o },
      importId: f,
      inputHasHeaders: l,
      segmentCode: s,
      segmentName: b
    }).finish(), this.dependencies = [o.dependency, t];
  }
  config;
  enclaveType = "decentriq.permutive-worker";
  dependencies;
  outputFormat = v.ComputeNodeFormat.RAW;
}
class I extends u {
  decode(c) {
    return X.PermutiveWorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
class xe {
  constructor(c, {
    domainUrl: t,
    apiName: o,
    productType: f,
    credentialsDependency: b
  }) {
    this.name = c;
    const s = f === "CORE" ? G.ImportRole.create({ core: {} }) : G.ImportRole.create({ marketingCloud: {} });
    this.config = G.SalesforceWorkerConfiguration.encodeDelimited({
      apiName: o,
      credentialsDependency: b,
      domainUrl: t,
      importRole: s
    }).finish(), this.dependencies = [b];
  }
  config;
  enclaveType = "decentriq.salesforce-worker";
  dependencies;
  outputFormat = v.ComputeNodeFormat.RAW;
}
class x extends u {
  decode(c) {
    return G.SalesforceWorkerConfiguration.decodeDelimited(
      c
    ).toJSON();
  }
}
function e(p) {
  return N.util.binary.hex.decode(p);
}
function ee(p) {
  const c = N.pem.decode(p)[0].body;
  return N.util.binary.raw.decode(c);
}
const a = ee(ce), d = ee(oe), m = N.util.binary.base64.decode(
  "gD63hSj3ScS+wuOeGrubXlq35N1c5Lby/S+T7MNTjxo="
), w = N.util.binary.base64.decode(
  "0GD7c3yP8xEc4Zl2zeuN2SlLvDVVocjsPSL8/Rl/7zg="
), i = N.util.binary.base64.decode(
  "MIIBPjCB46ADAgECAgEBMAwGCCqGSM49BAMCBQAwEjEQMA4GA1UEAwwHUm9vdCBDQTAgFw0yMzAxMDEwMDAwMDBaGA8yMDcwMDEwMTAwMDAwMFowEjEQMA4GA1UEAwwHUm9vdCBDQTBZMBMGByqGSM49AgEGCCqGSM49AwEHA0IABOnqVIfFUOqBS5tt8g5srIRfFJkYl61kbOKaAH3gi1QICmItg69K5hdtye3loMCUNiQGSnqS/TeGJuXjTqGpsSWjJjAkMA4GA1UdDwEB/wQEAwIBBjASBgNVHRMBAf8ECDAGAQH/AgEAMAwGCCqGSM49BAMCBQADSAAwRQIgX9UM7iEie/2Q5YJiXYn8qHT/FlAOy593VKACQZcqMgsCIQDyxkeooGwU85ilwj0oJOXg4YF7ohVZOuKagomsThIFKg=="
), ie = [
  e(
    "372499d1b652b98aa1cde6d146136ad2b3e8f93b8223c367087577a73b76813928ad25545327032f7dc44a288965eb8e7f16179dbdb3a71fddc36cc19478ce47"
  ),
  e(
    "ce8a61aea3f76bbdd05706bcbfb4ade4c65b33ad41f49d0e89dec177951117d247781a3195de2e85399b7117d9eee2f6f2c2e5d21064a4d7e2815380212f0937"
  ),
  e(
    "86185338a275af6b5e26e06a21b4e0c65db0fc9033e4a24e27cb528321726dc152f28b08c05493c48e8fba3047aba6f0a0dd01d3eebb055b3318c1029c0a74ee"
  ),
  e(
    "7d2e30af8f43cc6de4e6c3ee59a7ab0d9ddfbff4caba3de0e54430215bd640c571d0e4b49d0cd1502fa74ae8a59475fe06dd9e7635500d584478e13f1191dc27"
  ),
  e(
    "02926acb4dab55b176946d75e5955154b11269dd8bfe7ff7bcd162b26ea47d8b9557bebd927e90667e34e6dbf9f1bb3bff4bdd36f41d2b755cccabf50270e324"
  ),
  e(
    "7102b9671cb139729cf41529cffbd45504c2a644947d56c53ec187e6cdde1d4b136a58958049c6d081362d5c4eac518ba6cbce73fba66d56a288b4b26b36c6f3"
  )
], fe = new Map(
  Object.entries({
    /* eslint-disable sort-keys-fix/sort-keys-fix */
    "decentriq.driver:v10": {
      name: "decentriq.driver",
      version: "10",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "799044e44e189338553b18706e32284725300926569bbec19af576557abfba19"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      clientProtocols: [3],
      decoder: new q()
    },
    "decentriq.driver:v11": {
      name: "decentriq.driver",
      version: "11",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "661cb988c03197f60a619fc4b6e28980790fefb6ab710f9d8994d42e9d00d8ed"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      clientProtocols: [4],
      decoder: new q()
    },
    "decentriq.driver:v12": {
      name: "decentriq.driver",
      version: "12",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "b24067659124bebeb3e83d15733a50ad72669a162484c3bb5488dba8e743a1d7"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      clientProtocols: [4],
      decoder: new q()
    },
    "decentriq.driver:v13": {
      name: "decentriq.driver",
      version: "13",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "0858710d10692cfd2f00c3f93cda35d125413beb5076b5ca2a7741d8260ed540"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      clientProtocols: [5],
      decoder: new q()
    },
    "decentriq.driver:v14": {
      name: "decentriq.driver",
      version: "14",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "6be4c9677818e70e2b75229617cb3b25c0b53642a7ad50867f9babb1d904d38e"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      clientProtocols: [5],
      decoder: new q()
    },
    "decentriq.driver:v16": {
      name: "decentriq.driver",
      version: "16",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "2e4fec5faa3fab558c8b6a248b97cba2824838329bd0a53e6014c14ed9026140"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      clientProtocols: [5],
      decoder: new q()
    },
    "decentriq.driver:v17": {
      name: "decentriq.driver",
      version: "17",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "c112b5aaa940100d7d70a590963b0cac71d889ff3f14587a590ffb8f42a576e1"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      clientProtocols: [5],
      decoder: new q()
    },
    "decentriq.driver:v18": {
      name: "decentriq.driver",
      version: "18",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "7690de11d11efb95b6977cdd75f99035513006790227e8fd7faf153e02d3cc50"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      clientProtocols: [5],
      decoder: new q()
    },
    "decentriq.driver:v19": {
      name: "decentriq.driver",
      version: "19",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "e3584803d8996bac8a090ae6f4f30c5fb6ebc91ad82080fedb1c82160eda529c"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      clientProtocols: [5],
      decoder: new q()
    },
    "decentriq.driver:v20": {
      name: "decentriq.driver",
      version: "20",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "ae201c5380a6a7c122f2a0e2762f13add664618c4e868e039e23174e66156892"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      clientProtocols: [6],
      decoder: new q()
    },
    "decentriq.driver:v21": {
      name: "decentriq.driver",
      version: "21",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "ae290dfdee2759066341697af5441993ff6df00359be52439c551c37416f77e1"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      clientProtocols: [6],
      decoder: new q()
    },
    "decentriq.driver:mrsigner": {
      name: "decentriq.driver",
      version: "mrsigner",
      proto: r.AttestationSpecification.create({
        intelDcapMrsigner: {
          mrsigner: e(
            "469ba38fe548952095beed8daf89f9629a9bd1644a01e218e770569b1e669ee9"
          ),
          isvprodid: 2,
          sigstoreRootOlpcJson: new TextEncoder().encode(de),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      clientProtocols: [6],
      decoder: new q()
    },
    "decentriq.sql-worker:v10": {
      name: "decentriq.sql-worker",
      version: "10",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "dcc9847948837a5cdb85d4fb13d6b77ff6ff5dab63bef35c95901adfa7f1a102"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new K()
    },
    "decentriq.sql-worker:v11": {
      name: "decentriq.sql-worker",
      version: "11",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "6812cea56521a8c495d12e4940b7cf66c54d8dbc03859f587db2ea22f68051c8"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new K()
    },
    "decentriq.sql-worker:v12": {
      name: "decentriq.sql-worker",
      version: "12",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "72ca63e791b03ab1a9136c67da8f4fec2cb505fcea8a611afe6e5f6751cc4dd9"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new K()
    },
    "decentriq.sql-worker:v13": {
      name: "decentriq.sql-worker",
      version: "13",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "fa0cdebc78fc6f1809cc91f0e6f8933ca0e3131d7e33e6b5b396582f976e7183"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new K()
    },
    "decentriq.sql-worker:v14": {
      name: "decentriq.sql-worker",
      version: "14",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "fb1b925f414e88cdde554ba49310edd9753af0f73b33ac8440509901e35785da"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new K()
    },
    "decentriq.sql-worker:v15": {
      name: "decentriq.sql-worker",
      version: "15",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "516f1b9f168d309b9a490b48b40f616bee62e31d4ca58bdb9f46ce6f5b89f490"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new K()
    },
    "decentriq.post-worker:v5": {
      name: "decentriq.post-worker",
      version: "5",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "52e363142aaefdfbb27e4cb248c3a96743bd917dcc97b05eb42ac1aa6b019860"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new z()
    },
    "decentriq.post-worker:v6": {
      name: "decentriq.post-worker",
      version: "6",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "95ff137db91d6ed5f187c9c69eed4e936c4200291ef65fd68bdf2dbe775958e3"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new z()
    },
    "decentriq.post-worker:v8": {
      name: "decentriq.post-worker",
      version: "8",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "517096c140d10deb5a081c5b7492953e6ee06b3796c8f191cc48e2785758e596"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new z()
    },
    "decentriq.post-worker:v9": {
      name: "decentriq.post-worker",
      version: "9",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "3829df22f1298b15626c7809e43b23bb298eed1fe85030ab4cd06d4a250475a2"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new z()
    },
    "decentriq.python-ml-worker-32-64:v10": {
      name: "decentriq.python-ml-worker-32-64",
      version: "10",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "9a6a0fd3d0652eae039011346c80cedf572c8e725cbb294a2067ce0a66e7c128c7baf370a77b1005eba3f98f467c9cde"
          ),
          authorizedChipIds: [
            e(
              "372499d1b652b98aa1cde6d146136ad2b3e8f93b8223c367087577a73b76813928ad25545327032f7dc44a288965eb8e7f16179dbdb3a71fddc36cc19478ce47"
            ),
            e(
              "ce8a61aea3f76bbdd05706bcbfb4ade4c65b33ad41f49d0e89dec177951117d247781a3195de2e85399b7117d9eee2f6f2c2e5d21064a4d7e2815380212f0937"
            ),
            e(
              "86185338a275af6b5e26e06a21b4e0c65db0fc9033e4a24e27cb528321726dc152f28b08c05493c48e8fba3047aba6f0a0dd01d3eebb055b3318c1029c0a74ee"
            ),
            e(
              "7d2e30af8f43cc6de4e6c3ee59a7ab0d9ddfbff4caba3de0e54430215bd640c571d0e4b49d0cd1502fa74ae8a59475fe06dd9e7635500d584478e13f1191dc27"
            ),
            e(
              "02926acb4dab55b176946d75e5955154b11269dd8bfe7ff7bcd162b26ea47d8b9557bebd927e90667e34e6dbf9f1bb3bff4bdd36f41d2b755cccabf50270e324"
            )
          ],
          roughtimePubKey: m
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v11": {
      name: "decentriq.python-ml-worker-32-64",
      version: "11",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "683b9ad485cfd3eb25c5d49739d1392552f044e736a1c15a3039407edfb0c3bbd9e397dd27ab866c0417e6acdc0794ca"
          ),
          authorizedChipIds: [
            e(
              "372499d1b652b98aa1cde6d146136ad2b3e8f93b8223c367087577a73b76813928ad25545327032f7dc44a288965eb8e7f16179dbdb3a71fddc36cc19478ce47"
            ),
            e(
              "ce8a61aea3f76bbdd05706bcbfb4ade4c65b33ad41f49d0e89dec177951117d247781a3195de2e85399b7117d9eee2f6f2c2e5d21064a4d7e2815380212f0937"
            ),
            e(
              "86185338a275af6b5e26e06a21b4e0c65db0fc9033e4a24e27cb528321726dc152f28b08c05493c48e8fba3047aba6f0a0dd01d3eebb055b3318c1029c0a74ee"
            ),
            e(
              "7d2e30af8f43cc6de4e6c3ee59a7ab0d9ddfbff4caba3de0e54430215bd640c571d0e4b49d0cd1502fa74ae8a59475fe06dd9e7635500d584478e13f1191dc27"
            ),
            e(
              "02926acb4dab55b176946d75e5955154b11269dd8bfe7ff7bcd162b26ea47d8b9557bebd927e90667e34e6dbf9f1bb3bff4bdd36f41d2b755cccabf50270e324"
            )
          ],
          roughtimePubKey: m
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v12": {
      name: "decentriq.python-ml-worker-32-64",
      version: "12",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "8c17b219d1c0e7ce224b9fd8716bca389f7e1c15df3d791ab7d8ef0dbb85554ae7fa3e7328d5d30cf277bedfd266ee5a"
          ),
          authorizedChipIds: [
            e(
              "372499d1b652b98aa1cde6d146136ad2b3e8f93b8223c367087577a73b76813928ad25545327032f7dc44a288965eb8e7f16179dbdb3a71fddc36cc19478ce47"
            ),
            e(
              "ce8a61aea3f76bbdd05706bcbfb4ade4c65b33ad41f49d0e89dec177951117d247781a3195de2e85399b7117d9eee2f6f2c2e5d21064a4d7e2815380212f0937"
            ),
            e(
              "86185338a275af6b5e26e06a21b4e0c65db0fc9033e4a24e27cb528321726dc152f28b08c05493c48e8fba3047aba6f0a0dd01d3eebb055b3318c1029c0a74ee"
            ),
            e(
              "7d2e30af8f43cc6de4e6c3ee59a7ab0d9ddfbff4caba3de0e54430215bd640c571d0e4b49d0cd1502fa74ae8a59475fe06dd9e7635500d584478e13f1191dc27"
            ),
            e(
              "02926acb4dab55b176946d75e5955154b11269dd8bfe7ff7bcd162b26ea47d8b9557bebd927e90667e34e6dbf9f1bb3bff4bdd36f41d2b755cccabf50270e324"
            )
          ],
          roughtimePubKey: m
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v13": {
      name: "decentriq.python-ml-worker-32-64",
      version: "13",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "46b53ba8ff69e0c739cc8a10811bc90aba3d802fdec6bb14f89ca0dc37ff546a70302285f0153c7e41a3eb0872eb92e0"
          ),
          authorizedChipIds: [
            e(
              "372499d1b652b98aa1cde6d146136ad2b3e8f93b8223c367087577a73b76813928ad25545327032f7dc44a288965eb8e7f16179dbdb3a71fddc36cc19478ce47"
            ),
            e(
              "ce8a61aea3f76bbdd05706bcbfb4ade4c65b33ad41f49d0e89dec177951117d247781a3195de2e85399b7117d9eee2f6f2c2e5d21064a4d7e2815380212f0937"
            ),
            e(
              "86185338a275af6b5e26e06a21b4e0c65db0fc9033e4a24e27cb528321726dc152f28b08c05493c48e8fba3047aba6f0a0dd01d3eebb055b3318c1029c0a74ee"
            ),
            e(
              "7d2e30af8f43cc6de4e6c3ee59a7ab0d9ddfbff4caba3de0e54430215bd640c571d0e4b49d0cd1502fa74ae8a59475fe06dd9e7635500d584478e13f1191dc27"
            ),
            e(
              "02926acb4dab55b176946d75e5955154b11269dd8bfe7ff7bcd162b26ea47d8b9557bebd927e90667e34e6dbf9f1bb3bff4bdd36f41d2b755cccabf50270e324"
            ),
            e(
              "7102b9671cb139729cf41529cffbd45504c2a644947d56c53ec187e6cdde1d4b136a58958049c6d081362d5c4eac518ba6cbce73fba66d56a288b4b26b36c6f3"
            )
          ],
          roughtimePubKey: m
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v14": {
      name: "decentriq.python-ml-worker-32-64",
      version: "14",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "7e51b8520f9c509401a0a663558f5bfdd83727e382fe98bd5be81314793608402bb9d0c055663dda6c76152efd15ce0c"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v16": {
      name: "decentriq.python-ml-worker-32-64",
      version: "16",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "8a820d9e1ac5e37267efcc3a703fad82eb0c9fb33bd5ffe43fa548cbe885c142890e306858c491b795602ee977f4d5a7"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v17": {
      name: "decentriq.python-ml-worker-32-64",
      version: "17",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "1003ebcf8740bcb2ed7eea7f07dd9b6e08d025341768e54bc6a27824cb2d799d1109436928d23fc1f8bb9173c063ffb7"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v18": {
      name: "decentriq.python-ml-worker-32-64",
      version: "18",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "7d6676ba14c429880836af7f6230a14a05d0130f1a4a66ca28393c1fbfca569e0ce151284e0ca86325efae1fd271f51a"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v19": {
      name: "decentriq.python-ml-worker-32-64",
      version: "19",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "4ce88a690b4ea1c8d2361c8a84578f27b3b97b4bdc1a21e4117b1effba5e94ad7db95eeee7510fd3d340e7b5c2494319"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v20": {
      name: "decentriq.python-ml-worker-32-64",
      version: "20",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "c766a31beb97525887cc9c096ef871fb5b50fcf4949e5c345750f0dbb5da647f90a50dd7184aa13e9496e994ac5b33b7"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v21": {
      name: "decentriq.python-ml-worker-32-64",
      version: "21",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "2edf7b49f55cb0c654c06c922134bf21b532d6892667e8af2f4ecb98021fcc1e5391f1f87ab7b9237d706fc209435a1a"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v22": {
      name: "decentriq.python-ml-worker-32-64",
      version: "22",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "490c7043fd83a4cedf2ca9d6cf128d302b406b5f1a8172ed48afc3e231f15621ece52d97babb89322592018907eed6d3"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v23": {
      name: "decentriq.python-ml-worker-32-64",
      version: "23",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "9d13a27344d211698052b8cb911c7a7624b614a9b416ce617894d3c7238925d0cd0f152400e234d39103390d7d3aec68"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v24": {
      name: "decentriq.python-ml-worker-32-64",
      version: "24",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "a98870cf9077d2cd6bcfdb9d0d4ddffdabca0386517a6dc75e7c315c7c191b91c31b47e375108f1745cf0aae70bf8c1c"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v25": {
      name: "decentriq.python-ml-worker-32-64",
      version: "25",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "d356a7728e7da8c697af46c9c81bb0b0907deba09d7d47ee8b82f915c4e97ebd58859c8d59717da3e3f5df2be9fcfcd3"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v26": {
      name: "decentriq.python-ml-worker-32-64",
      version: "26",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "927a4df939f6665eba5bc1755480e4c9066994e96c99f4f5d65cc826aa22ff2a64e95ded8bb74259909553907514a5fc"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v27": {
      name: "decentriq.python-ml-worker-32-64",
      version: "27",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "9073be9a9a682c138f1cfcc24ee3a17059993e06b55addc62f7ccc4fd4a61436441c014e3977d4708de1d9541fae21b2"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-ml-worker-32-64:v28": {
      name: "decentriq.python-ml-worker-32-64",
      version: "28",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "e29300600e5806bdc7b10e603a6572d569e3e776b662c8f5d73a175a58d6d1c967bffd432895218e8e4669747e8b7751"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-synth-data-worker-32-64:v10": {
      name: "decentriq.python-synth-data-worker-32-64",
      version: "10",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "8b9f780b6524418f4fc8d4bc8b2450c82e09aefb17b36aebfcf0630b6dea8b1451f12c35203d6ddc9c94b74351db9a22"
          ),
          authorizedChipIds: [
            e(
              "372499d1b652b98aa1cde6d146136ad2b3e8f93b8223c367087577a73b76813928ad25545327032f7dc44a288965eb8e7f16179dbdb3a71fddc36cc19478ce47"
            ),
            e(
              "ce8a61aea3f76bbdd05706bcbfb4ade4c65b33ad41f49d0e89dec177951117d247781a3195de2e85399b7117d9eee2f6f2c2e5d21064a4d7e2815380212f0937"
            ),
            e(
              "86185338a275af6b5e26e06a21b4e0c65db0fc9033e4a24e27cb528321726dc152f28b08c05493c48e8fba3047aba6f0a0dd01d3eebb055b3318c1029c0a74ee"
            ),
            e(
              "7d2e30af8f43cc6de4e6c3ee59a7ab0d9ddfbff4caba3de0e54430215bd640c571d0e4b49d0cd1502fa74ae8a59475fe06dd9e7635500d584478e13f1191dc27"
            ),
            e(
              "02926acb4dab55b176946d75e5955154b11269dd8bfe7ff7bcd162b26ea47d8b9557bebd927e90667e34e6dbf9f1bb3bff4bdd36f41d2b755cccabf50270e324"
            )
          ],
          roughtimePubKey: m
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-synth-data-worker-32-64:v11": {
      name: "decentriq.python-synth-data-worker-32-64",
      version: "11",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "4b5c2949eddbe215607a81df61ba75084e705922c76af792d39e437c4ef1f33cc64e04d4bbd40e395bcc3d4bf8daef70"
          ),
          authorizedChipIds: [
            e(
              "372499d1b652b98aa1cde6d146136ad2b3e8f93b8223c367087577a73b76813928ad25545327032f7dc44a288965eb8e7f16179dbdb3a71fddc36cc19478ce47"
            ),
            e(
              "ce8a61aea3f76bbdd05706bcbfb4ade4c65b33ad41f49d0e89dec177951117d247781a3195de2e85399b7117d9eee2f6f2c2e5d21064a4d7e2815380212f0937"
            ),
            e(
              "86185338a275af6b5e26e06a21b4e0c65db0fc9033e4a24e27cb528321726dc152f28b08c05493c48e8fba3047aba6f0a0dd01d3eebb055b3318c1029c0a74ee"
            ),
            e(
              "7d2e30af8f43cc6de4e6c3ee59a7ab0d9ddfbff4caba3de0e54430215bd640c571d0e4b49d0cd1502fa74ae8a59475fe06dd9e7635500d584478e13f1191dc27"
            ),
            e(
              "02926acb4dab55b176946d75e5955154b11269dd8bfe7ff7bcd162b26ea47d8b9557bebd927e90667e34e6dbf9f1bb3bff4bdd36f41d2b755cccabf50270e324"
            )
          ],
          roughtimePubKey: m
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-synth-data-worker-32-64:v12": {
      name: "decentriq.python-synth-data-worker-32-64",
      version: "12",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "c817b0eefc1549b5a077b2a6ddb955bc233824d84301d782643598b48900cde52821b968fb9ab27ae831d4926ac641b7"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-synth-data-worker-32-64:v14": {
      name: "decentriq.python-synth-data-worker-32-64",
      version: "14",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "9b40ac320e2f142b707f65f055b9a4ef9f7fbe9e1cf2ba5d41cc782f3a614eefa324509b45a6df857dd383c8bb1297b5"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-synth-data-worker-32-64:v15": {
      name: "decentriq.python-synth-data-worker-32-64",
      version: "15",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "46696d754525bdeb7b5738eb3ab4b41c966938396b6dd7b4a7180f4d6b26b8044d46fc49d0800d88467c539060392e96"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-synth-data-worker-32-64:v16": {
      name: "decentriq.python-synth-data-worker-32-64",
      version: "16",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "a6c41eba6549d247e9323fa2762dd62985a05ed5d89527c6b2ec5d8b0521d98615e422cb04c3656ac8c50f88f3c8a67e"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-synth-data-worker-32-64:v17": {
      name: "decentriq.python-synth-data-worker-32-64",
      version: "17",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "26a9c458b2326c4dc63ec619429590da0d9a38a25ba51a759cb3e04cd744e045bf9ca091dc484c0c1b304fc23b689fba"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-synth-data-worker-32-64:v18": {
      name: "decentriq.python-synth-data-worker-32-64",
      version: "18",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "7c15aafecef3fa78b0e9b1b195b96bb1c00d445e8914ba0243ff66619de346d06e40a95e06b1934c5e3d4ed37686e053"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-synth-data-worker-32-64:v19": {
      name: "decentriq.python-synth-data-worker-32-64",
      version: "19",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "597b25c7cf5de4de8065511747c30bc029d07bc0f935f5b66bb1554c4d3e1e604d52bf5f7be003bda5ef23e7d221ef55"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-synth-data-worker-32-64:v20": {
      name: "decentriq.python-synth-data-worker-32-64",
      version: "20",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "09d30afb27e60a7744a5726ca0a278caf9fb7143d283daeedfec8a6b5e8bd12970fc98ddc487abb7d5db3013a1d4123e"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-synth-data-worker-32-64:v21": {
      name: "decentriq.python-synth-data-worker-32-64",
      version: "21",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "c6ffa25f1a931deb9fb148d76c6a9169d8ca9cad2f7aeb347718066ac1760eca5eae4f120f5666aba4f6a2512c392b8c"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.python-synth-data-worker-32-64:v22": {
      name: "decentriq.python-synth-data-worker-32-64",
      version: "22",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "e92a42cc0b5e722c181e19d836e72ad6cea6b33fd2571dcc5a1153bd96a3992a283176566e3d16dee19f36b2cc065183"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.r-latex-worker-32-32:v10": {
      name: "decentriq.r-latex-worker-32-32",
      version: "10",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "5f0a74f6c0633d9d4781d8c112617ce386507b86869b341a89b2183c8e41f01032c3ec9821567530f023f26c0f8a846d"
          ),
          authorizedChipIds: [
            e(
              "372499d1b652b98aa1cde6d146136ad2b3e8f93b8223c367087577a73b76813928ad25545327032f7dc44a288965eb8e7f16179dbdb3a71fddc36cc19478ce47"
            ),
            e(
              "ce8a61aea3f76bbdd05706bcbfb4ade4c65b33ad41f49d0e89dec177951117d247781a3195de2e85399b7117d9eee2f6f2c2e5d21064a4d7e2815380212f0937"
            ),
            e(
              "86185338a275af6b5e26e06a21b4e0c65db0fc9033e4a24e27cb528321726dc152f28b08c05493c48e8fba3047aba6f0a0dd01d3eebb055b3318c1029c0a74ee"
            ),
            e(
              "7d2e30af8f43cc6de4e6c3ee59a7ab0d9ddfbff4caba3de0e54430215bd640c571d0e4b49d0cd1502fa74ae8a59475fe06dd9e7635500d584478e13f1191dc27"
            ),
            e(
              "02926acb4dab55b176946d75e5955154b11269dd8bfe7ff7bcd162b26ea47d8b9557bebd927e90667e34e6dbf9f1bb3bff4bdd36f41d2b755cccabf50270e324"
            )
          ],
          roughtimePubKey: m
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.r-latex-worker-32-32:v11": {
      name: "decentriq.r-latex-worker-32-32",
      version: "11",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "de88718b50772045dd4427f0a7b83e80aa5c6a4e33664b88bc37e9663677d724bb3708ede4fca930506f344662141997"
          ),
          authorizedChipIds: [
            e(
              "372499d1b652b98aa1cde6d146136ad2b3e8f93b8223c367087577a73b76813928ad25545327032f7dc44a288965eb8e7f16179dbdb3a71fddc36cc19478ce47"
            ),
            e(
              "ce8a61aea3f76bbdd05706bcbfb4ade4c65b33ad41f49d0e89dec177951117d247781a3195de2e85399b7117d9eee2f6f2c2e5d21064a4d7e2815380212f0937"
            ),
            e(
              "86185338a275af6b5e26e06a21b4e0c65db0fc9033e4a24e27cb528321726dc152f28b08c05493c48e8fba3047aba6f0a0dd01d3eebb055b3318c1029c0a74ee"
            ),
            e(
              "7d2e30af8f43cc6de4e6c3ee59a7ab0d9ddfbff4caba3de0e54430215bd640c571d0e4b49d0cd1502fa74ae8a59475fe06dd9e7635500d584478e13f1191dc27"
            ),
            e(
              "02926acb4dab55b176946d75e5955154b11269dd8bfe7ff7bcd162b26ea47d8b9557bebd927e90667e34e6dbf9f1bb3bff4bdd36f41d2b755cccabf50270e324"
            )
          ],
          roughtimePubKey: m
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.r-latex-worker-32-32:v12": {
      name: "decentriq.r-latex-worker-32-32",
      version: "12",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "9f06e56b2ad9fb74988a4a84b891735adfa6cc5189c83f4daf0eade78db682f7c89c8a2285a40b1fceeffcfdfdbbd663"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.r-latex-worker-32-32:v14": {
      name: "decentriq.r-latex-worker-32-32",
      version: "14",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "a0276c0d0e3ca7462e59e9c6243a3110e24f773cf23b4dae94ecc7bf2c6fb758b1f22443330430106f20a8b78e3c5ffe"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.r-latex-worker-32-32:v15": {
      name: "decentriq.r-latex-worker-32-32",
      version: "15",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "a15bb713f5985a690333092e25afbb072b8d6d1858af760127f49cb81fbe1a33d15984f8f37e40a2e01c170cb4a05cc1"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.r-latex-worker-32-32:v16": {
      name: "decentriq.r-latex-worker-32-32",
      version: "16",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "dfecd4a6642efca9fdf5720711b490b996b1526bd2a24e42f12d67d772641653119745f8c679a5a27c10bf0b06331a8b"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.r-latex-worker-32-32:v17": {
      name: "decentriq.r-latex-worker-32-32",
      version: "17",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "7f212fb3d7d60c74438d12edfa2e17212a05a6906b881ab7153e2c85bb9235d0ef167c858dcddd89050838bc4e57df49"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.r-ml-worker-32-32:v1": {
      name: "decentriq.r-ml-worker-32-32",
      version: "1",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "8ad29c4692d73649da5509b25675ba92d500b8d09f149f3bc7dfac6e8eb8abd8f14cd298264449aaa8bf41134ca91aad"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.r-ml-worker-32-32:v2": {
      name: "decentriq.r-ml-worker-32-32",
      version: "2",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "4e39f4b1fef97de8ec2780b4680be18e5b7f7d1a602063ae048d55b4f3e8ba1ba30d4a3f9702428630015a89df74f530"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.r-ml-worker-32-32:v3": {
      name: "decentriq.r-ml-worker-32-32",
      version: "3",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "335f667989cae85e79e0157cc81efed14e3a1f5a4da332aa523bd491ecc0d3f359bd8385e56cb5554ba1479db1b4fa3e"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.r-ml-worker-32-32:v4": {
      name: "decentriq.r-ml-worker-32-32",
      version: "4",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "9ace50262ee78976d1eac65346508cc5ab19fcba7329b5f708371e689117b2a20223a64653f40041cbfeb10fb3d700fa"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.r-ml-worker-32-32:v5": {
      name: "decentriq.r-ml-worker-32-32",
      version: "5",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "e922fdf2821ed16753c853d4c444b319f3b71e689823d750805b3f8971b06dc4ef69d1942d75db0b64a0d4b193f99430"
          ),
          roughtimePubKey: w,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.dataset-s3-sink-worker:v2": {
      name: "decentriq.s3-sink-worker",
      version: "2",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "963ca160598716c0c94722a8b376b5b647302cc369c0344b2f3bae3dfb1e8eb3"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new D()
    },
    "decentriq.dataset-s3-sink-worker:v3": {
      name: "decentriq.s3-sink-worker",
      version: "3",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "09c34e9750a6e18ec7b18d633a5ffb5533c9d5be2bf896eb280717e3da4f2024"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new D()
    },
    "decentriq.dataset-s3-sink-worker:v5": {
      name: "decentriq.s3-sink-worker",
      version: "5",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "293b598b660a982bbf6dcc9db44f8c30fcb8a13d0150960434a5669a60d4cb43"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new D()
    },
    "decentriq.dataset-s3-sink-worker:v6": {
      name: "decentriq.s3-sink-worker",
      version: "6",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "eabe3e4efe8e8472d6945ca1b1a238b6702fad50fe4864cd80dc089f7712d740"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new D()
    },
    "decentriq.dataset-s3-sink-worker:v7": {
      name: "decentriq.s3-sink-worker",
      version: "7",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "1a7e771493f850e6addd7cbada59ec17023c4fa55b922a02c5db9677ade03c70"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new D()
    },
    "decentriq.dataset-s3-sink-worker:v8": {
      name: "decentriq.s3-sink-worker",
      version: "8",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "2688a034d8c871d653b485efd7053d2bfcdf97f150cd4080202c14ec36dfbaa8"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new D()
    },
    "decentriq.dataset-s3-sink-worker:v9": {
      name: "decentriq.s3-sink-worker",
      version: "9",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "8e570acd9474cd2083cf50a5396f0e6f6e329e80b124ad1f52f8942d5f333be5"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new D()
    },
    "decentriq.dataset-s3-sink-worker:v10": {
      name: "decentriq.s3-sink-worker",
      version: "10",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "cd966163f0489c6b13ca7f21fc32bd11b1d8d17050b56854ff34b698c5e24172"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new D()
    },
    "decentriq.dataset-s3-sink-worker:v11": {
      name: "decentriq.s3-sink-worker",
      version: "11",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "156ede4c7662d528045c7979bb34093411283e3df8accadae17604b83d9386a6"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new D()
    },
    "decentriq.dataset-s3-sink-worker:v12": {
      name: "decentriq.s3-sink-worker",
      version: "12",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "14af5b657be03edaa54a1e9ebdce8ee0a1f978d891223cba5297cf688972ed93"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new D()
    },
    "decentriq.dataset-s3-sink-worker:v13": {
      name: "decentriq.s3-sink-worker",
      version: "13",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "8c50e1900bc0a91de89fb994c1c25ce5c146bccabf2a4af25d6d962d748fe8e3"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new D()
    },
    "decentriq.dataset-salesforce-worker:v1": {
      name: "decentriq.salesforce-worker",
      version: "1",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "ddf17a7c5a3ef4515c4b1ad68cc590dd4de035610cc326c2577ba00e75dc119c"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new x()
    },
    "decentriq.dataset-salesforce-worker:v2": {
      name: "decentriq.salesforce-worker",
      version: "2",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "655077117b0445a998e08820a9f53623f604aa425b5666505f6cc4b8cbce2ecc"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new x()
    },
    "decentriq.dataset-salesforce-worker:v3": {
      name: "decentriq.salesforce-worker",
      version: "3",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "36fdb68f83eefb656f386ac36128225be23a87bf91753b01ed7e6c3d59dfe768"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new x()
    },
    "decentriq.dataset-salesforce-worker:v4": {
      name: "decentriq.salesforce-worker",
      version: "4",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "47d0036aba8804192764a2dcbb4332e980c6551fce5410a499bc65c792df22d9"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new x()
    },
    "decentriq.dataset-salesforce-worker:v5": {
      name: "decentriq.salesforce-worker",
      version: "5",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "faadd1139d7a13b51be59d2798bbf4ecf05eb6da6bfb5d3f64e998a69b1307b4"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new x()
    },
    "decentriq.permutive-worker:v1": {
      name: "decentriq.permutive-worker",
      version: "1",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "cc7d4a42538cf6facb683d5b21be8124bad7e470dc3910073fff451d7143de0f"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new I()
    },
    "decentriq.permutive-worker:v2": {
      name: "decentriq.permutive-worker",
      version: "2",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "7452e8513773a8e47a37575c04a6991689be8b5084e32f9c4d44ae4d9728b466"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new I()
    },
    "decentriq.permutive-worker:v3": {
      name: "decentriq.permutive-worker",
      version: "3",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "1e6d951bdf25b17f787fc71c7e753ddc79fadeac66143b1f119ca7ac3c54075a"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new I()
    },
    "decentriq.permutive-worker:v4": {
      name: "decentriq.permutive-worker",
      version: "4",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "77816c60a5d1d530756f51472a5fdf5fe5fff7bf38e0a82dc5aacda53ae4eb3b"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new I()
    },
    "decentriq.permutive-worker:v5": {
      name: "decentriq.permutive-worker",
      version: "5",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "819bea0ef2890a4a99d8a755c9401c1c145886fd10f6740f4ecb2dc2480b87e9"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new I()
    },
    "decentriq.permutive-worker:v6": {
      name: "decentriq.permutive-worker",
      version: "6",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "c3a6d22f27641f0e79de16b18893927e99d8777a83a7a02736377e45946dfbb5"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new I()
    },
    "decentriq.dataset-sink-worker:v1": {
      name: "decentriq.dataset-sink-worker",
      version: "1",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "3ffc8524bfc85837340ebfaabe4775f498b5040bbd84f30dcf62f2b1f86a61f4"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new A()
    },
    "decentriq.dataset-sink-worker:v2": {
      name: "decentriq.dataset-sink-worker",
      version: "2",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "971a45b16095ee1dbff897d42058fa1c1b024d2a2ea2267deda1575f6be21e86"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new A()
    },
    "decentriq.dataset-sink-worker:v3": {
      name: "decentriq.dataset-sink-worker",
      version: "3",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "bcb7afdc6bc64e638b44047515e3a8a4b8445282fee342fb9666f0531cd6fca4"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new A()
    },
    "decentriq.dataset-sink-worker:v5": {
      name: "decentriq.dataset-sink-worker",
      version: "5",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "effbd9945e6e2efcebbb657cd9a9b456e0d2c3171878472a45b7f3f949d060b2"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new A()
    },
    "decentriq.dataset-sink-worker:v6": {
      name: "decentriq.dataset-sink-worker",
      version: "6",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "57444a373aa9c0a451666c2b7cc838c4d2691de2da09c11eb1525b6475fc3d7e"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new A()
    },
    "decentriq.dataset-sink-worker:v7": {
      name: "decentriq.dataset-sink-worker",
      version: "7",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "e0add8800f0d1878f61ed46754b0f06dd97fc0e08553820a76d7c5b4e97ced92"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new A()
    },
    "decentriq.dataset-sink-worker:v8": {
      name: "decentriq.dataset-sink-worker",
      version: "8",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "eb64acb0564d432e900f6ba9b626fe7c4445038187e7eaf69ce105362c83a14c"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new A()
    },
    "decentriq.dataset-sink-worker:v9": {
      name: "decentriq.dataset-sink-worker",
      version: "9",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "c0f77142f680c21a22e52dabe62b2e638be02ea3f2caa1e07e41e361235ca4b1"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new A()
    },
    "decentriq.data-source-s3-worker:v1": {
      name: "decentriq.data-source-s3-worker",
      version: "1",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "67b8fe452b4724d85e81210f163936dc3ad1cf9c8602939a27ebe9afa00673ff"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new S()
    },
    "decentriq.data-source-s3-worker:v2": {
      name: "decentriq.data-source-s3-worker",
      version: "2",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "f3e7b026ecd80b766bf3073b0aabcae4f55f91611c8de9cba8e671f1b9597ad7"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new S()
    },
    "decentriq.data-source-s3-worker:v4": {
      name: "decentriq.data-source-s3-worker",
      version: "4",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "e42ddd0aa4a355582bc35128c7008ba8aa197604f3b6c1745c74701438ac5605"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new S()
    },
    "decentriq.data-source-s3-worker:v5": {
      name: "decentriq.data-source-s3-worker",
      version: "5",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "2bbfda5a90e833bdff07ca84828d99cbce48cb55f61db2dab00106c03bd358b6"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new S()
    },
    "decentriq.data-source-s3-worker:v6": {
      name: "decentriq.data-source-s3-worker",
      version: "6",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "1a913c06eb2c8e1ea7d87d572424aa8421802374747aba12a2bd7c92ab00f621"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new S()
    },
    "decentriq.data-source-s3-worker:v7": {
      name: "decentriq.data-source-s3-worker",
      version: "7",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "d13bf659173f7b0158254f2819bebde2fb4221e2e562e7b772317c293e857973"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new S()
    },
    "decentriq.data-source-s3-worker:v8": {
      name: "decentriq.data-source-s3-worker",
      version: "8",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "72ef6d1943d14ef8004c1419f2028c353131aaa6f167779eabbaa38a4e400285"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new S()
    },
    "decentriq.data-source-s3-worker:v9": {
      name: "decentriq.data-source-s3-worker",
      version: "9",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "dc75fb83569fdbae366d80f0cdabd4b7e2dcb5cc01d3858f2ce68c4069ef3055"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new S()
    },
    "decentriq.data-source-s3-worker:v10": {
      name: "decentriq.data-source-s3-worker",
      version: "10",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "864d9a1117dfc483044156d2676891c763ef1cc7961ba9e10c44c7567768682f"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new S()
    },
    "decentriq.data-source-s3-worker:v11": {
      name: "decentriq.data-source-s3-worker",
      version: "11",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "0b42b202bb1027113bbe8c84588f0aa368b24c1a950eeee270feff76c785f84c"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new S()
    },
    "decentriq.data-source-snowflake-worker:v1": {
      name: "decentriq.data-source-snowflake-worker",
      version: "1",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "303f2c98573b322a06b88fbebd05db398607aac0a04023e0cb8d80ea822cfd3e"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new B()
    },
    "decentriq.data-source-snowflake-worker:v2": {
      name: "decentriq.data-source-snowflake-worker",
      version: "2",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "0ce5941c05297438d256c5d409afc3f444b09f6bf5a145accbc83525a68459ec"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new B()
    },
    "decentriq.data-source-snowflake-worker:v4": {
      name: "decentriq.data-source-snowflake-worker",
      version: "4",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "31642671f42befad424cdf7389bfa7fe0ca08dab454d4f2cac46fb34f618d1ae"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new B()
    },
    "decentriq.data-source-snowflake-worker:v5": {
      name: "decentriq.data-source-snowflake-worker",
      version: "5",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "b607c0b71e470c23b09ea0c2b9af22e4f350129a5df055887b17e02e02aba2e1"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new B()
    },
    "decentriq.data-source-snowflake-worker:v6": {
      name: "decentriq.data-source-snowflake-worker",
      version: "6",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "29aa718daf610ff5d5b2f91f7ce79cc6f5a7f682d72552d2bdbbb07eb4f3d9d2"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new B()
    },
    "decentriq.meta-sink-worker:v1": {
      name: "decentriq.meta-sink-worker",
      version: "1",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "b1cc081fa868d6acb4293ff3b287c3da075d11ce2e1eeeb692e311eac9711fff"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new g()
    },
    "decentriq.meta-sink-worker:v2": {
      name: "decentriq.meta-sink-worker",
      version: "2",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "7d73f04c12338eafc8cc01747ee1817f2cf86d87ca435c27beda965f5ecd2d77"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new g()
    },
    "decentriq.meta-sink-worker:v4": {
      name: "decentriq.meta-sink-worker",
      version: "4",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "785c9f94e339ec07e92dd2f39859b587da16a5104c89b879eb8589ba590ae947"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new g()
    },
    "decentriq.meta-sink-worker:v5": {
      name: "decentriq.meta-sink-worker",
      version: "5",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "347cec31ae007bebfe8feedcea51c824688a5bad395e2342fefb9fb0adb7e5e1"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new g()
    },
    "decentriq.meta-sink-worker:v6": {
      name: "decentriq.meta-sink-worker",
      version: "6",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "2bbdce9aa3fd5d4003389978d487c0a548ee16353cdd6d9e7cffb61f29700725"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new g()
    },
    "decentriq.meta-sink-worker:v7": {
      name: "decentriq.meta-sink-worker",
      version: "7",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "41f0e66c7d5667aa1a7e5dfb894b8218775e08ff7b19900f6284bc8446b276a5"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new g()
    },
    "decentriq.meta-sink-worker:v8": {
      name: "decentriq.meta-sink-worker",
      version: "8",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "fc2147f660d81ee9bc585ecccad0ed55a6f3d5b75b5dc7c0cdc73713233549ae"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new g()
    },
    "decentriq.meta-sink-worker:v9": {
      name: "decentriq.meta-sink-worker",
      version: "9",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "637041940ffd4d1368bcb785a4edfcf57f78a4809c6862754c78b6ca35fb1681"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new g()
    },
    "decentriq.meta-sink-worker:v10": {
      name: "decentriq.meta-sink-worker",
      version: "10",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "6b977aeb93b1fd866abf56f3611a2ec3ac5cd26592464ae993d00ac44df443b5"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new g()
    },
    "decentriq.google-ad-manager-worker:v1": {
      name: "decentriq.google-ad-manager-worker",
      version: "1",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "1502c2398e83de066b88050deec30376b2c3dbc54974ced2c7ef37950006a403"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new R()
    },
    "decentriq.google-ad-manager-worker:v2": {
      name: "decentriq.google-ad-manager-worker",
      version: "2",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "40ed3e2e9b82d1b23d2380e9cb293a59197a979a5ce2918cb0b50f64604bcfeb"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new R()
    },
    "decentriq.google-ad-manager-worker:v3": {
      name: "decentriq.google-ad-manager-worker",
      version: "3",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "eae60f5bc9ca4cb67fd253206a9a8b4d723f0ce799bb6c9c9b366eb9b7ba8cbd"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new R()
    },
    "decentriq.google-ad-manager-worker:v4": {
      name: "decentriq.google-ad-manager-worker",
      version: "4",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "299741f85a17bab044857bd6a91efb996f3ed492271f31ccc9e9ce98d5127670"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new R()
    },
    "decentriq.google-ad-manager-worker:v5": {
      name: "decentriq.google-ad-manager-worker",
      version: "5",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "de3b3da04d59a350b9dcb559dd493132b449b02bfcd03e857257bd481201d08a"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new R()
    },
    "decentriq.google-ad-manager-worker:v6": {
      name: "decentriq.google-ad-manager-worker",
      version: "6",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "af6927c990e68b1d8e2b91db19393a14ee6f5321297755b51220fa12a58569cd"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new R()
    },
    "decentriq.google-ad-manager-worker:v7": {
      name: "decentriq.google-ad-manager-worker",
      version: "7",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "2807bb0eb44f40b66932f6607008583ece0444e166aa316f5057675d030e2b2c"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new R()
    },
    "decentriq.google-dv-360-sink-worker:v1": {
      name: "decentriq.google-dv-360-sink-worker",
      version: "1",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "3a00807af2ec87b9de3760188d112c494dd1a41877fbae30ecebb607ceafa3e7"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new h()
    },
    "decentriq.google-dv-360-sink-worker:v3": {
      name: "decentriq.google-dv-360-sink-worker",
      version: "3",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "b035a0bdb2ea9522ac96efce0008fbc6aa60a01228c2bc377b3aa0a683920b4a"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new h()
    },
    "decentriq.google-dv-360-sink-worker:v4": {
      name: "decentriq.google-dv-360-sink-worker",
      version: "4",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "3ec53f55dc174a812fd2898ac10c0a6135c3268b6bdd05bad29da35f102be51e"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new h()
    },
    "decentriq.google-dv-360-sink-worker:v5": {
      name: "decentriq.google-dv-360-sink-worker",
      version: "5",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "30a9ef92fc5cfbcddb9632de7a3c48d9d341004847ec44d1f6415e0ff3aa373e"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new h()
    },
    "decentriq.google-dv-360-sink-worker:v6": {
      name: "decentriq.google-dv-360-sink-worker",
      version: "6",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "b7b45c7844cc4d2322d1b66b77c478bffb24b8d79f88fd501c41769607d72ef0"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new h()
    },
    "decentriq.google-dv-360-sink-worker:v7": {
      name: "decentriq.google-dv-360-sink-worker",
      version: "7",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "26561cc7e12bbc49f8ea3cf162a9368bdf7a346cda1d4e1e0f2f3fd1552a7b32"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new h()
    },
    "decentriq.google-dv-360-sink-worker:v8": {
      name: "decentriq.google-dv-360-sink-worker",
      version: "8",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "f9d219021d963063d3f6cd43cb18308436a384291e44f1a843b7b652475973ac"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new h()
    },
    "decentriq.google-dv-360-sink-worker:v9": {
      name: "decentriq.google-dv-360-sink-worker",
      version: "9",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "7e96601783e5859b0da393f8cd8875cc06afe167b9e6c61356713d814a3ee5f0"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new h()
    },
    "decentriq.google-dv-360-sink-worker:v10": {
      name: "decentriq.google-dv-360-sink-worker",
      version: "10",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "e715fca598d0ec654db7fed7a6b8cd8ca85a2bbe78f0508612096a1203851d0d"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new h()
    },
    "decentriq.azure-blob-storage-worker:v2": {
      name: "decentriq.azure-blob-storage-worker",
      version: "2",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "2db293783d1d072aa7ce3ff148df4f504d091165db7053165fe81af80afab71f"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new M()
    },
    "decentriq.azure-blob-storage-worker:v3": {
      name: "decentriq.azure-blob-storage-worker",
      version: "3",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "48df661285eae40318e02a50ff35b269e9f26bac29f369753da55633578a07c0"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new M()
    },
    "decentriq.azure-blob-storage-worker:v4": {
      name: "decentriq.azure-blob-storage-worker",
      version: "4",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "60b9bcee93116a95b69412c71b3d7586372d21d880d50101d477d437cf982945"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new M()
    },
    "decentriq.azure-blob-storage-worker:v5": {
      name: "decentriq.azure-blob-storage-worker",
      version: "5",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "dc6108885998dfafea3fbc2864f3e014f9c59fbcb15909bbe5af4f51ccd09873"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new M()
    },
    "decentriq.azure-blob-storage-worker:v6": {
      name: "decentriq.azure-blob-storage-worker",
      version: "6",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "e09a4e370f977d7f0899a40dc06d291442665f941b7f38eac38e806ac26e817e"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new M()
    },
    "decentriq.sqlite-container-worker-32-64:v1": {
      name: "decentriq.sqlite-container-worker-32-64",
      version: "1",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "e7fbd9f884286e5c419bd13b6d1e91dfd4e93312b3f31461282b30674505d39641f4166f6e12dcdf8a61495cccc1c7a4"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.sqlite-container-worker-32-64:v2": {
      name: "decentriq.sqlite-container-worker-32-64",
      version: "2",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "e984073ae4fe0f86cc57f6017c96e9b832ca28f33d595af1e21c9a03ad12717baca2e21fbb3209920e463fb9c321a5af"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.sqlite-container-worker-32-64:v4": {
      name: "decentriq.sqlite-container-worker-32-64",
      version: "4",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "6bcbeb7611f50f91d9c906cdda9aa5ad7439439ff7876343fb7b47aadd4b345aecc2b75208eb60f9cee424fd04412980"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.sqlite-container-worker-32-64:v5": {
      name: "decentriq.sqlite-container-worker-32-64",
      version: "5",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "049e736a02d9a7fa0d85a07edc51e42cadf8beee7c92838f791905f08acbc4a51d0b995dcbf3205068d0388c16bd4817"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.sqlite-container-worker-32-64:v6": {
      name: "decentriq.sqlite-container-worker-32-64",
      version: "6",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "5a4a634beb5bc6422becdec1332f8cd5c5742599909ac71534e53b87f231a2d6194d3fdd4a801629621b92d05ce6f18c"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.sqlite-container-worker-32-64:v7": {
      name: "decentriq.sqlite-container-worker-32-64",
      version: "7",
      proto: r.AttestationSpecification.create({
        amdSnp: {
          amdArkDer: d,
          measurement: e(
            "0c487e45b7f9719efa8e603bca3b8f5db0077a3979353133d3a065211dcf75457cb19cfa159ea2b8c703a89ec3c6d4c6"
          ),
          roughtimePubKey: m,
          decentriqDer: i
        }
      }),
      workerProtocols: [1],
      decoder: new n()
    },
    "decentriq.adform-dsp-worker:v1": {
      name: "decentriq.adform-dsp-worker",
      version: "1",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "b08e50cbd7b1951e895d79af6a5aa53e35e8970addeb329ec4fbcabcf38ac07d"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new O()
    },
    "decentriq.adform-dsp-worker:v2": {
      name: "decentriq.adform-dsp-worker",
      version: "2",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "16470c766f7b3c69d6229dbe8a20497bdf12a58f9d0203bd0384f4cf976d9895"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new O()
    },
    "decentriq.adform-dsp-worker:v3": {
      name: "decentriq.adform-dsp-worker",
      version: "3",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "bf301f81eeaa807fb91e831eae7ff3204615e9cffacd3b1e1d9d3a77b69861b7"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new O()
    },
    "decentriq.microsoft-dsp-worker:v1": {
      name: "decentriq.microsoft-dsp-worker",
      version: "1",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "dcd948b39844e29a869b9daf37db0cf82430d704097b2884e1d5ffacd5d0ac95"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new T()
    },
    "decentriq.microsoft-dsp-worker:v2": {
      name: "decentriq.microsoft-dsp-worker",
      version: "2",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "c3125522eb0f16c1affd71aad2cbe29035781f4256b8a8cb48e7860882d842dd"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new T()
    },
    "decentriq.microsoft-dsp-worker:v3": {
      name: "decentriq.microsoft-dsp-worker",
      version: "3",
      proto: r.AttestationSpecification.create({
        intelDcap: {
          mrenclave: e(
            "9bf0d5290aa14f628ee86a185b6ccf090c907f11a9c3e966bd8e91a98ffd1e45"
          ),
          dcapRootCaDer: a
        }
      }),
      workerProtocols: [1],
      decoder: new T()
    }
  })
);
class P {
  specifications;
  constructor(c) {
    this.specifications = c;
  }
  list() {
    const c = Array.from(this.specifications.keys());
    return c.sort(), c;
  }
  versions(c) {
    const t = /* @__PURE__ */ new Map();
    return c.forEach((o) => {
      const f = this.specifications.get(o);
      if (f !== void 0) {
        const b = o.split(":")[0];
        t.set(b, f);
      } else
        throw new Error(
          `No available enclave specification for enclave ${o}`
        );
    }), t;
  }
  getAll() {
    return Array.from(this.specifications.values());
  }
  merge(c) {
    return new P(
      new Map([...this.specifications, ...c.specifications])
    );
  }
  static getLatestByName(c) {
    return c.reduce((o, f) => {
      const b = o.get(f.name);
      return (!b || f.version === "mrsigner" || b.version !== "mrsigner" && Number(b.version) < Number(f.version)) && o.set(f.name, f), o;
    }, /* @__PURE__ */ new Map());
  }
  static attestationSpecsAreEqual(c, t) {
    return j(c.proto) === j(t.proto);
  }
}
const re = new P(fe), be = (p, c) => {
  const t = P.getLatestByName(re.getAll()), o = P.getLatestByName(p), f = /* @__PURE__ */ new Map();
  if (c)
    for (const [
      b,
      s
    ] of o.entries()) {
      const l = s, k = t.get(b);
      k && (l.decoder = k.decoder), s.name === "decentriq.driver" && (l.clientProtocols = k && P.attestationSpecsAreEqual(
        s,
        k
      ) ? k.clientProtocols : [te]), f.set(b, l);
    }
  else
    for (const [
      b,
      s
    ] of t.entries()) {
      const l = o.get(b);
      l && P.attestationSpecsAreEqual(
        s,
        l
      ) && f.set(b, s);
    }
  return f;
}, ze = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EnclaveSpecifications: P,
  amdSnpArkDer: d,
  decentriqChipIdEndorsementRoot: i,
  enclaveSpecifications: re,
  getLatestEnclaveSpecsPerType: be,
  intelSgxDcapRootCaDer: a,
  newRoughtimePublicKey: w,
  oldAmdSnpAuthorizedChipIds: ie,
  roughtimePublicKey: m
}, Symbol.toStringTag, { value: "Module" }));
export {
  Ce as A,
  n as C,
  Re as D,
  P as E,
  Ee as G,
  Ne as M,
  Be as P,
  he as S,
  Ae as a,
  We as b,
  Me as c,
  ye as d,
  re as e,
  Ie as f,
  be as g,
  ne as h,
  xe as i,
  ge as j,
  z as k,
  $ as l,
  Pe as m,
  K as n,
  ze as o,
  Ke as p,
  a as q,
  d as r,
  m as s,
  w as t,
  i as u,
  ie as v
};
//# sourceMappingURL=attestation-CPbOedrn.js.map
